// Constants.
import * as AlertConstants from 'constants/AlertConstants';

function receiveSendAlertMessage(message, status) {
  return {
    type: AlertConstants.ALERT_MESSAGE_SEND,
    message,
    status,
  };
}

export function sendAlertMessage(message, status = 'success') {
  return dispatch => {
    dispatch(receiveSendAlertMessage(message, status));
  };
}

export function clearAlertMessage() {
  return dispatch => {
    dispatch(receiveSendAlertMessage('', ''));
  };
}
